// Component disabled on purpose
// Allas doesn't use AffiliateGallery now, it's styled just in case, if something changed

import StandaloneAffiliateGallery from 'base/components/AffiliateGallery';

export default (() => null) as typeof StandaloneAffiliateGallery;
